import { RouteObject } from "react-router-dom";

import { ArchiveProcedure } from "@/features/archive/pages/archive-procedure/ArchiveProcedure";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const archiveRoutes: RouteObject[] = [
	{
		path: "archive/*",
		children: [
			{
				index: true,
				lazy: async () => {
					const { Archive } = await import("@/features/archive/pages/Archive");
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<Archive />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: "procedure/:id",
				children: [
					{
						index: true,
						lazy: async () => {
							await import("@/features/archive/pages/Archive");
							return { Component: ArchiveProcedure };
						},
					},
					{
						path: "data",
						lazy: async () => {
							const { ArchiveDataGridPage } =
								await import("@/features/archive/pages/data-grid/ArchiveDataGridPage");
							return { Component: ArchiveDataGridPage };
						},
					},
				],
			},
		],
	},
];
